module.exports = __webpack_public_path__ + "static/media/ViewMoreBG.259d6db4.png";